import { Phone } from "@mui/icons-material"
import { Box, Button, Grid, Stack, Typography } from "@mui/material"
import ReservationModal from "../ReservationModal/ReservationModal"
import { useState } from "react"


function ReservationComp() {
    const [openModal, setOpenModal] = useState(false)
    const handleClick = () => {
        setOpenModal(true)
    }
    const handleClose = () => {
        setOpenModal(false)
    }
    return (
        <>
            <ReservationModal openVar={openModal} onClose={handleClose}></ReservationModal>
            <Grid item xs={12} sx={{
                backgroundColor: "primary.main",
                p: 3,
                color: "white"
            }}>
                <Box sx={{
                    display: "flex",
                    justifyContent: "space-between"
                }}>
                    <Stack>
                        <Typography variant="caption" sx={{
                            textTransform: "uppercase",
                            fontWeight: 500
                        }}>Rezervovat telefonicky </Typography>
                        <Box sx={{
                            display: "flex",
                            alignContent: "center",
                            gap: 1
                        }}>
                            <Phone />
                            <Typography component="a" href='tel:+420777276064' variant="body1" sx={{
                                textTransform: "uppercase",
                                fontWeight: 600
                            }}>777 276 064</Typography>
                        </Box>
                    </Stack>
                    <Button variant="contained" onClick={handleClick} color="secondary">
                        Rezervovat online
                    </Button>
                </Box>
            </Grid>
        </>
    )
}

export default ReservationComp